import { useEffect, useMemo } from 'react';
import dayjs, { UnitTypeLongPlural } from 'dayjs';
import duration from 'dayjs/plugin/duration';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';
import { TTimeStatus } from '@r1-frontend/shared/hooks/useTimer';

dayjs.extend(duration);

interface ITimerConfig {
    units: Partial<{ [unit in Exclude<UnitTypeLongPlural, 'dates'> | 'weeks']: number }>,
    format?: string,
    postfix: string,
}

const timerConfig: ITimerConfig = {
    units: {},
    postfix: '',
};

interface IProps {
    status: TTimeStatus,
    onBtnClick: () => void,
    isLoading?: boolean,
    isDisabled?: boolean,
    autoStart?: boolean,
    seconds: number,
    onStart: (seconds: number) => void,
}

export const ButtonWithTimer = ({
    status,
    onBtnClick,
    isLoading,
    isDisabled,
    autoStart = false,
    seconds,
    onStart,
}: IProps): JSX.Element => {
    const startHandler = () => {
        if (seconds === 0) {
            onStart(60);
            onBtnClick();
        }
    };

    useEffect(() => {
        if (autoStart) {
            startHandler();
        }
    }, [autoStart]);

    const timerText = useMemo(() => {
        const _minutes = ~~(seconds / 60);

        timerConfig.units.minutes = _minutes;
        timerConfig.units.seconds = seconds % 60;
        timerConfig.format = _minutes ? 'm:ss' : 's';
        timerConfig.postfix = _minutes ? 'мин' : 'сек';

        const timer = dayjs.duration(timerConfig.units).format(timerConfig.format);

        return `Повторный код через ${timer}${NBSP}${timerConfig.postfix}`;
    }, [seconds]);

    return (
        <Button
            size={'large'}
            bType={'action'}
            onClick={startHandler}
            disabled={isDisabled || !!seconds}
            loading={isLoading}
        >
            {status === 'progress' ? timerText : 'Отправить код еще раз'}
        </Button>
    );
};
